<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="d-sm-flex gap-1 align-items-center mb-4">
              <h5 class="card-title fw-semibold mb-3 mb-sm-0 me-auto">Daftar Pesan</h5>
              <form @submit.prevent="getDataList" class="d-flex gap-1">
                <div class="input-group">
                  <input
                    v-model="cariTitle"
                    type="text"
                    class="form-control bg-light"
                    placeholder="Pencarian..."
                    autocomplete="off"
                  >
                  <button class="btn btn-primary">Cari</button>
                </div>
              </form>
            </div>
            <hr class="border-0 bg-primary pt-1 rounded my-4">

            <ul class="nav gap-1 mb-4">
              <li class="nav-item">
                <button
                  class="btn btn btn-success"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  @click="add()"
                >Kirim Pesan Baru</button>
              </li>
            </ul>

            <div class="table-responsive">
              <table class="table align-middle table-striped table-hover">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th class="text-nowrap w-25" scope="col">
                      <a href="#" class="link-dark">
                        Pengirim
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="w-50" scope="col">Pesan</th>
                    <th class="text-center text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Tanggal
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-center text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Status
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-end" scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(req, idx) in dataList" :key="idx">
                    <th scope="row">{{ idx + 1 }}</th>
                    <td class="text-nowrap">{{ safeGet(req, 'user.user_profile.fullname') }}</td>
                    <td class="text-nowrap">
                      <small>Subjek : {{ req.subject || '-' }}</small>
                      <br>
                      {{ (req.itemId[0].messages || '').slice(0, 70) + ((req.itemId[0].messages && req.itemId[0].messages.length > 70) ? '...' : '') }}
                    </td>

                    <td class="text-center">{{ formatDate(req.itemId[0].createdAt) }}</td>
                    <td class="text-center">
                      <template v-if="req && req.site_status">
                        <small
                          :class="req.site_status.id == 9 ? 'text-bg-success' : 'text-bg-secondary'"
                          class="badge fs-1 bg-opacity-75"
                        >{{ safeGet(req, 'site_status.status_name') }}</small>
                      </template>
                    </td>
                    <td class="text-nowrap text-end">
                      <button
                        class="btn btn-sm btn-outline-warning me-1"
                        @click="edit(req.id, safeGet(req, 'user.user_profile.fullname'))"
                        title="Detail"
                        data-bs-toggle="modal"
                        data-bs-target="#modalDetailMessage"
                      >
                        <i class="ti ti-message fs-3"></i>
                      </button>
                      <router-link
                        :to="`/form-user?type=responden&userId=${safeGet(req, 'user.id')}`"
                        class="btn btn-sm btn-outline-primary"
                        title="Detail"
                      >
                        <i class="ti ti-user fs-3"></i>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <b-pagination
              class="justify-content-center"
              v-model="page"
              :total-rows="countDataList"
              :per-page="pageSize"
              prev-text="Previous"
              next-text="Next"
              @change="handlePageChange"
              size="md"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Detail Message -->
    <form @submit.prevent="onSubmitItem">
      <div
        class="modal fade"
        id="modalDetailMessage"
        tabindex="-1"
        aria-labelledby="modalDetailMessageLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h1
                class="modal-title fs-5"
                id="modalDetailMessagelLabel"
              >Detail Pesan - {{ pengirim }}</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row g-3">
                <template v-for="(req, i) in mesItemList">
                  <div
                    v-if="req.user && req.user.type === 'patient'"
                    class="col-10 col-lg-8"
                    :key="i"
                  >
                    <div
                      class="alert alert-success rounded-top-5 rounded-end-5 p-4 m-0 fw-medium shadow"
                    >{{req.messages}}</div>
                    <div class="small mt-1">
                      <b>{{safeGet(req, 'user.user_profile.fullname')}}</b>
                      - {{formatDate(req.createdAt)}}
                    </div>
                  </div>
                  <div v-else class="col-10 col-lg-8 ms-auto" :key="i">
                    <div
                      class="alert alert-primary rounded-top-5 rounded-start-5 p-4 m-0 fw-medium shadow"
                    >{{req.messages}}</div>
                    <div class="small mt-1 text-end">
                      <b>{{safeGet(req, 'user.user_profile.fullname')}}</b>
                      - {{formatDate(req.createdAt)}}
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="modal-footer d-block">
              <hr class="rounded mb-3">

              <div class="form-floating">
                <textarea
                  v-model="formItem.messages"
                  class="form-control"
                  placeholder="Pesan..."
                  id="floatingTextarea2"
                  style="height: 100px"
                ></textarea>
                <label for="floatingTextarea2">Isi Pesan *</label>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-dark" data-bs-dismiss="modal">Batal</button>
              <button type="submit" class="btn btn-success">Kirim Pesan</button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <!-- Modal -->
    <form @submit.prevent="onSubmit">
      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="modalNewExaminationlLabel">Pesan Baru</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="mb-4">
                <label for class="form-label">Klasifikasi *</label>
                <div>
                  <div class="form-check form-check-inline">
                    <input
                      v-model="form.klasifikasi"
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio1"
                      value="Umum"
                      autocomplete="off"
                      required
                    >
                    <label class="form-check-label" for="inlineRadio1">Umum</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      v-model="form.klasifikasi"
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio2"
                      value="Personal"
                      autocomplete="off"
                    >
                    <label class="form-check-label" for="inlineRadio2">Personal</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      v-model="form.klasifikasi"
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio6"
                      value="Usia Kehamilan"
                      autocomplete="off"
                    >
                    <label class="form-check-label" for="inlineRadio6">Usia Kehamilan</label>
                  </div>
                </div>
              </div>

              <div
                v-if="form.klasifikasi == 'Personal' && userList && userList.Records"
                class="mb-4"
              >
                <label for class="form-label">Penerima / Responden *</label>
                <v-select
                  v-model="userID"
                  multiple
                  :placeholder="`-- Pilih --`"
                  label="label"
                  :options="userList.Records.map(elem => ({label: `${elem.user_profile.fullname} - ${elem.user_profile.nik}`, code: elem.id}))"
                />

                <!-- <select
                  v-model="form.responden"
                  class="form-select mb-1"
                  id="floatingSelect"
                  multiple
                  autocomplete="off"
                  required
                >
                  <option
                    v-for="(item, i) in userList.Records"
                    :value="item.id"
                    :key="`ul${i}`"
                  >{{ safeGet(item, 'user_profile.fullname') }} - {{safeGet(item, 'user_profile.nik')}}</option>
                </select>-->
                <!-- <small
                  class="fst-italic"
                >** Tekan & tahan tombol CTRL/Command untuk pilih lebih dari satu.</small> -->
              </div>

              <div v-if="form.klasifikasi == 'Usia Kehamilan'" class="mb-4">
                <label for class="form-label">Usia Kehamilan *</label>
                <select
                  v-model="form.pregnancy_age"
                  class="form-select mb-1"
                  id="floatingSelect"
                  multiple
                  autocomplete="off"
                  required
                >
                  <option v-for="n in 28" :value="n" :key="`sp${n}`">{{ n }} minggu</option>
                </select>
                <small
                  class="fst-italic"
                >** Tekan & tahan tombol CTRL/Command untuk pilih lebih dari satu.</small>
              </div>

              <div class="mb-4">
                <label for class="form-label">Subjek *</label>
                <input
                  v-model="form.subject"
                  class="form-control"
                  placeholder="Subjek..."
                  value="Pesan Baru"
                  autocomplete="off"
                  required
                >
              </div>
              <div>
                <label for class="form-label">Pesan *</label>
                <textarea
                  v-model="form.messages"
                  class="form-control"
                  placeholder="Isi Pesan..."
                  rows="3"
                  autocomplete="off"
                  required
                ></textarea>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-dark" data-bs-dismiss="modal">Batal</button>
              <button type="submit" class="btn btn-success">Simpan</button>
              <!-- liveToastBtn -->
            </div>
          </div>
        </div>
      </div>
    </form>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'
import { allMixin } from '@/mixins/allMixin.js'

export default {
	mixins: [allMixin],
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			user_login: JSON.parse(localStorage.getItem('user_login')).data,
			token: localStorage.getItem('token'),
			order: 'desc',
			page: 1,
			pageSize: 30,
			pageSizes: [10, 20, 50],
			userID: '',
			id: '',
			pengirim: '',
			form: {
				id: '',
				subject: '',
				messages: '',
				klasifikasi: 'Umum',
				responden: [],
				pregnancy_age: []
			},
			formItem: {
				userId: '',
				messages: ''
			},
			cariTitle: '',
			url: 'messages',
			method: 'post'
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		this.getDataList()
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
		this.$store.dispatch('location/getDataThird', {
			url: `users`,
			params: {
				type: 'patient',
				offset: 0,
				limit: 10000,
				order: 'desc'
			}
		})
	},
	computed: {
		...mapGetters({
			dataList: 'location/getDCLocation',
			countDataList: 'location/getCountDCLocation',
			mesItemList: 'location/getDataSecond',
			userList: 'location/getDataThird'
		}),
		userId: {
			// getter
			get() {
				return this.$route.query.userId || ''
			}
		},
		pregnancy_age() {
			return this.form.pregnancy_age.join(',')
		},
		// responden() {
		// 	return this.form.responden.join(',')
		// },
		responden() {
			return this.userID.map((u) => u.code).join(',')
		}
	},
	methods: {
		getDataList(reset_pagination, from = 'all') {
			if (reset_pagination) {
				this.page = 1
			}
			this.$store
				.dispatch('location/getData', {
					url: `messages`,
					params: {
						messages: this.cariTitle,
						userId: this.userId,
						offset: this.page - 1,
						limit: this.pageSize,
						order: this.order
					}
				})
				.then(() => {
					console.log('doneeeeeeeeeee')
				})
		},
		handlePageChange(value) {
			this.page = value
			this.getDataList()
		},
		handlePageSizeChange(event) {
			this.pageSize = parseInt(event.target.value)
			this.page = 1
			this.getDataList()
		},
		onSubmit() {
			this.form.responden = this.responden
			this.$store
				.dispatch('location/createNewRecord', {
					data: this.form,
					url: 'messages/' + this.user_login.id,
					method: this.method
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.getDataList()
						document.querySelector('#exampleModal [data-bs-dismiss="modal"]').click()
						this.userID = ''
						this.form = {
							id: '',
							title: '',
							description: '',
							datetime: '',
							location: '',
							url: '',
							klasifikasi: 'Umum',
							responden: [],
							pregnancy_age: [],
							statusId: '1'
						}
					} else {
					}
				})
		},
		deleteData(id) {
			this.$store
				.dispatch('location/createNewRecord', {
					url: 'user_schedules/' + id,
					method: 'DELETE'
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.getDataList()
					} else {
					}
				})
		},
		edit(id, pengirim) {
			this.id = id
			this.pengirim = pengirim
			this.$store.dispatch('location/getDataSecond', {
				url: `messages_item/${id}`,
				params: {
					offset: 0,
					limit: 10000,
					order: 'asc'
				}
			})
		},
		onSubmitItem() {
			console.log('form iterm', this.formItem)
			this.formItem.userId = this.user_login.id
			this.$store
				.dispatch('location/createNewRecord', {
					data: this.formItem,
					url: 'messages_item/' + this.id,
					method: 'POST'
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.$store.dispatch('location/getDataSecond', {
							url: `messages_item/${this.id}`,
							params: {
								offset: 0,
								limit: 10000,
								order: 'asc'
							}
						})

						document.querySelector('#exampleModal [data-bs-dismiss="modal"]').click()
						this.formItem.messages = ''
					} else {
					}
				})
		},

		add() {
			this.userID = ''
			this.form = {
				id: '',
				title: '',
				description: '',
				datetime: '',
				location: '',
				url: '',
				klasifikasi: 'Umum',
				responden: [],
				pregnancy_age: []
				// statusId: '1'
			}
			this.method = 'post'
		}
	}
}
</script>

<style lang="scss">
.file {
	position: relative;
	overflow: hidden;
}

.input-file {
	position: absolute;
	font-size: 50px;
	opacity: 0;
	right: 0;
	top: 0;
}
</style>
